import React from 'react';
export function PhoneFrame({
  children
}: {
  children: ReactNode;
}) {
  return <div className="min-h-screen w-full bg-gradient-to-br from-[#E6EEF7] via-[#EFF5FB] to-[#DDE8F3] flex items-center justify-center p-0 sm:p-8 relative" data-id="element-94">
      {/* Ambient outer glow */}
      <div className="hidden sm:block absolute w-[700px] h-[700px] bg-minerva-blue/20 rounded-full blur-[160px] pointer-events-none" data-id="element-95" />
      <div className="hidden sm:block absolute bottom-1/4 right-1/4 w-[400px] h-[400px] bg-minerva-cyan/15 rounded-full blur-[120px] pointer-events-none" data-id="element-96" />

      <div className="relative w-full h-[100dvh] sm:h-[850px] sm:max-h-[90vh] sm:max-w-[420px] sm:aspect-[9/16] bg-gradient-to-b from-white via-[#F6FAFD] to-[#EBF2F9] sm:rounded-[44px] sm:shadow-[0_40px_120px_-15px_rgba(0,80,114,0.3)] sm:border sm:border-white overflow-hidden flex flex-col" data-id="element-97">
        {children}
      </div>
    </div>;
}